// extracted by mini-css-extract-plugin
module.exports = {"root":"AppShell-module__root___Yexdu","appShell":"AppShell-module__appShell___cl5pA"};